import graphql from "babel-plugin-relay/macro";
import { ChangeEmail } from "components/account/ChangeEmail";
import { ErrorMessage } from "components/shared/ErrorMessage";
import { LoadingRegion } from "components/shared/LoadingRegion";
import { accountMessages } from "domain/account/accountMessages";
import { EmailQuery } from "generatedQueries/EmailQuery.graphql";
import { FC } from "react";
import Label from "reactstrap/lib/Label";
import { Message } from "shared/components/Message";
import { Query } from "shared/components/Query";
import { sharedMessages } from "shared/sharedMessages";

export const Email: FC = () => <main>
    <h1 className="h2"><Message message={accountMessages.changeYourEmailAddressTitle} /></h1>
    <hr aria-hidden="true" />
    <Query<EmailQuery>
        query={graphql`
            query EmailQuery {
                account {
                    email
                }
            }`}
        variables={{}}>
        {({ error, props }) => {
            return <LoadingRegion hasError={!!error} isLoading={!props} contentName={accountMessages.changeYourEmailAddressTitle}>
                {(() => {
                    if (error) {
                        return <ErrorMessage message={sharedMessages.requestFailedBody} heading={sharedMessages.requestFailedTitle} />;
                    }

                    if (!props) {
                        return;
                    }

                    const { account } = props;

                    if (!account) {
                        return <ErrorMessage message={sharedMessages.requestFailedBody} heading={sharedMessages.requestFailedTitle} />;
                    }

                    return <>
                        <div className="form-group row">
                            <Label className="col-form-label col-sm-2" for="current">
                                <Message message={accountMessages.currentEmailAddressLabel} />
                            </Label>
                            <div className="col-sm-4">
                                <input id="current" className="form-control-plaintext" value={account.email} readOnly={true} />
                            </div>
                        </div>
                        <ChangeEmail />
                    </>;
                })()}
            </LoadingRegion>
        }}
    </Query>
</main>;
